import { BulkLoad } from '@react-pdf/font';

export const poppinsFont: BulkLoad = {
  family: 'Poppins',
  fonts: [
    {
      src: '/fonts/Poppins-Regular.ttf',
      fontWeight: 400,
    },
    {
      src: '/fonts/Poppins-Medium.ttf',
      fontWeight: 500,
    },
    {
      src: '/fonts/Poppins-SemiBold.ttf',
      fontWeight: 600,
    },
    {
      src: '/fonts/Poppins-Italic.ttf',
      fontWeight: 400,
      fontStyle: 'italic',
    },
    {
      src: '/fonts/Poppins-MediumItalic.ttf',
      fontWeight: 500,
      fontStyle: 'italic',
    },
    {
      src: '/fonts/Poppins-SemiBoldItalic.ttf',
      fontWeight: 600,
      fontStyle: 'italic',
    },
  ],
} as const;

export const proximaNovaFont: BulkLoad = {
  family: 'Proxima Nova',
  fonts: [
    {
      src: '/fonts/ProximaNova-Thin.ttf',
      fontWeight: 100,
    },
    {
      src: '/fonts/ProximaNova-Thin.ttf',
      fontWeight: 100,
      fontStyle: 'italic',
    },
    {
      src: '/fonts/ProximaNova-Light.ttf',
      fontWeight: 300,
    },
    {
      src: '/fonts/ProximaNova-Light.ttf',
      fontWeight: 300,
      fontStyle: 'italic',
    },
    {
      src: '/fonts/ProximaNova-Regular.ttf',
      fontWeight: 400,
    },
    {
      // Fallback: no italic .ttf available — use Regular to prevent font resolution error
      src: '/fonts/ProximaNova-Regular.ttf',
      fontWeight: 400,
      fontStyle: 'italic',
    },
    {
      src: '/fonts/ProximaNova-Semibold.ttf',
      fontWeight: 600,
    },
    {
      src: '/fonts/ProximaNova-Semibold.ttf',
      fontWeight: 600,
      fontStyle: 'italic',
    },
    {
      src: '/fonts/ProximaNova-Bold.ttf',
      fontWeight: 700,
    },
    {
      // Fallback: no italic .ttf available — use Bold to prevent font resolution error
      src: '/fonts/ProximaNova-Bold.ttf',
      fontWeight: 700,
      fontStyle: 'italic',
    },
  ],
} as const;

export const montserratFont: BulkLoad = {
  family: 'Montserrat',
  fonts: [
    {
      src: '/fonts/Montserrat-Regular.ttf',
      fontWeight: 400,
    },
    {
      src: '/fonts/Montserrat-Medium.ttf',
      fontWeight: 500,
    },
    {
      src: '/fonts/Montserrat-SemiBold.ttf',
      fontWeight: 600,
    },
    {
      src: '/fonts/Montserrat-Italic.ttf',
      fontWeight: 400,
      fontStyle: 'italic',
    },
    {
      src: '/fonts/Montserrat-MediumItalic.ttf',
      fontWeight: 500,
      fontStyle: 'italic',
    },
    {
      src: '/fonts/Montserrat-SemiBoldItalic.ttf',
      fontWeight: 600,
      fontStyle: 'italic',
    },
  ],
} as const;
